import React from "react";
import WorkTitle from "./WorkTitle";

export type WorkListProps = {
  works: string[];
};

/**
 * 作品名リスト
 */
export default function WorkList({ works }: WorkListProps) {
  if (works[0] === "") {
    // console.log("作品なし");
    return;
  }

  return (
    <div className="relative">
      {/* @note「space-x-1」は2行以降の先頭で左に間隔が空くため指定しない。 */}
      <div className="mt-3 max-h-[62px] space-y-0.5 overflow-hidden">
        {works.map((work, index) => {
          if (!work.length) {
            return;
          }

          return (
            <React.Fragment key={`${work}-${index}`}>
              <WorkTitle
                title={work}
                className="mr-1 md:mr-3"
              />
            </React.Fragment>
          );
        })}
      </div>
      {/* 疑似要素で代用できない場合は明示的に要素を置く */}
      {/* <div className="absolute bottom-0 right-0 pl-2">…</div> */}
    </div>
  );
}
